import React from "react";
import { IKImage } from "imagekitio-next";

type StoreAvatarImageProps = {
  image?: string | null;
  alt: string;
  className?: string;
  size?: number;
  fallbackPath?: string;
};

const DEFAULT_SIZE = 48;
const DEFAULT_FALLBACK = "avatar.png";
const urlEndpoint = process.env.NEXT_PUBLIC_BASE_IMAGE_KIT_URL;

const StoreAvatarImage: React.FC<StoreAvatarImageProps> = ({
  image,
  alt,
  className = "",
  size = DEFAULT_SIZE,
  fallbackPath = DEFAULT_FALLBACK,
}) => {
  const imageUrl = image || fallbackPath;

  const combinedClassName = ["object-cover", className].filter(Boolean).join(" ");

  return (
    <IKImage
      urlEndpoint={urlEndpoint}
      src={imageUrl}
      alt={alt}
      width={size}
      height={size}
      className={combinedClassName}
    />
  );
};

export default StoreAvatarImage;
